// src/theme/index.ts
import { createDarkTheme, createLightTheme, type BrandVariants } from "@fluentui/react-components";

const trixxoGreen: BrandVariants = {
  10: "#0f1a00",
  20: "#1e3300",
  30: "#2d4d00",
  40: "#3c6600",
  50: "#4a7f00",
  60: "#599900",
  70: "#68ac15",
  80: "#76b82a",
  90: "#88c43e",
  100: "#9acf52",
  110: "#acdb67",
  120: "#bee77b",
  130: "#cff090",
  140: "#ddf5a8",
  150: "#eafabf",
  160: "#f4fdd8",
};

const brandOverrides = {
  fontFamilyBase: '"Titillium Web", "Bierstadt", "Segoe UI", sans-serif',
  colorBrandBackground: "#76b82a",
  colorBrandBackgroundHover: "#76b82a",
  colorBrandBackgroundPressed: "#76b82a",
  colorBrandBackgroundSelected: "#76b82a",
  colorBrandForeground1: "#76b82a",
  colorBrandForeground2: "#76b82a",
  colorBrandForeground2Hover: "#76b82a",
  colorBrandForegroundInverted: "#76b82a",
  colorBrandForegroundLink: "#76b82a",
  colorBrandForegroundLinkHover: "#76b82a",
  colorBrandForegroundLinkPressed: "#76b82a",
  colorBrandForegroundLinkSelected: "#76b82a",
  colorBrandStroke1: "#76b82a",
  colorBrandStroke2: "#76b82a",
  colorStrokeFocus2: "#76b82a",
  colorCompoundBrandBackground: "#76b82a",
  colorCompoundBrandBackgroundHover: "#76b82a",
  colorCompoundBrandBackgroundPressed: "#76b82a",
  colorCompoundBrandForeground1: "#76b82a",
  colorCompoundBrandStroke: "#76b82a",
};

export const trixxoLightTheme = {
  ...createLightTheme(trixxoGreen),
  ...brandOverrides,
};

export const trixxoDarkTheme = {
  ...createDarkTheme(trixxoGreen),
  ...brandOverrides,
};
